import OpenLocationCode from "./openlocationcode";
const CODE_PRECISION=11;
export default function (location){
    var code = OpenLocationCode.encode(location.latitude, location.longitude,CODE_PRECISION);
    code = toShortCode(code);
    return code;
}



function toShortCode(code){
    var cShort =  code.substring(2).replace("+","");
    return cShort;
}



function toFullCode(code){
    var cFull = "8F" + code.substring(0,6) + "+" + code.substring(6);
    return cFull
}